import React, { useEffect, useState, useContext, useRef } from "react";
import { RiCloseFill } from "react-icons/ri";
import { FaHeart } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import Loader2 from '../../DashboardComponents/Loader/Loader2.jsx';

import CameraModal from "../../DashboardComponents/ImageUpload/CameraModel.js";

import { updatewhiteironimages, updateirontestdata, updatepreferredclub } from "../../../Api/contact.js";

import { ForwardFittingContext } from "../ForwardFittingContext.js";

import { API_URL } from "../../../Api/config.js";
import { FaCheck } from "react-icons/fa6";
import { getCurrentUser } from "../../../Api/auth.js";
import { IoClose } from "react-icons/io5";

const IronStudioData = ({ remoteData, projectid }) => {
  const { remotefittingdata, setRemotefittingdata, updateremotefitting } = useContext(ForwardFittingContext);

  const [isLoading, setIsLoading] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);


  const colors = [
    {
      name: "White",
      ironClass: "white",
      ironColor: "#ffffff",
      ironLabel: "White",
      preferredClub: "",
      ironKey: "whiteiron",
      isOpen: true,
    },
    {
      name: "Black",
      isOpen: true,
      ironClass: "black",
      ironColor: "#ffffff",
      ironLabel: "Black",
      preferredClub: "",
      ironKey: "blackiron"
    },
    {
      name: "Blue",
      isOpen: true,
      ironLabel: "Blue",
      ironClass: "blue",
      ironColor: "#ffffff",
      preferredClub: "",
      ironKey: "blueiron"
    },
    {
      name: "Pink",
      isOpen: true,
      ironClass: "pink",
      ironColor: "#ffffff",
      preferredClub: "",
      ironLabel: "Pink",
      ironKey: "pinkiron"
    },
    {
      name: "Purple",
      isOpen: true,
      ironLabel: "Purple",
      ironClass: "purple",
      ironColor: "#ffffff",
      preferredClub: "",
      ironKey: "purpleiron"

    },
    {
      name: "Red",
      isOpen: true,
      ironLabel: "Red",
      ironClass: "red",
      ironColor: "#ffffff",
      preferredClub: "",
      ironKey: "rediron"
    },
    {
      name: "Orange",
      isOpen: true,
      ironLabel: "Orange",
      ironClass: "orange",
      ironColor: "#ffffff",
      preferredClub: "",
      ironKey: "orangeiron"
    },
    {
      name: "Green",
      isOpen: true,
      ironLabel: "Green",
      ironClass: "green",
      ironColor: "#ffffff",
      preferredClub: "",
      ironKey: "greeniron"
    },
  ];


  const [ironData, setIronData] = useState(colors);

  const [currentIron, setCurrentIron] = useState(null);

  const [ironDataModal, setIronDataModal] = useState(false);
  const [ironDataButtonStatus, setIronDataButtonStatus] = useState(true);

  useEffect(() => {
    // Map through the colors array and replace the values from mongoData based on ironKey

    const updatedIronData = colors.map(color => {
      const mongoIron = remoteData?.irondata?.[color.ironKey];
      console.log("mongoIronmongoIron", mongoIron);
      if (mongoIron) {
        return {
          ...color,
          name: mongoIron?.name,
          preferredClub: mongoIron?.preferred_club,
          isOpen: mongoIron?.isopen
        };
      }
      return color; // return original if no corresponding mongo data found
    });

    setIronData(updatedIronData);
    setIronDataButtonStatus(remoteData?.irondata?.status);
  }, [remoteData]);


  const handleCloseModal = () => {
    //window.scrollTo(0, scrollPosition);
    setCurrentIron(null);
    setIronDataModal(false);
  };


  useEffect(() => {
    if (currentIron != null) {
      const whiteIron = ironData.find(color => color.ironClass == currentIron.ironClass);
      setCurrentIron({
        ironClass: whiteIron.ironClass,
        ironColor: whiteIron.ironColor,
        preferredClub: whiteIron.preferredClub,
        ironKey: whiteIron.ironKey,
      });
    }
    console.log("iron data", ironData);
  }, [ironData]);


  const handleSaveIron = async (ironName, key) => {
    setIsLoading(true);
    const ironObject = ironData.find(color => color.ironClass === ironName);

    const formData = new FormData();

    // Function to append image to formData
    function appendImageToFormData(image, fieldName) {
      if (image instanceof File) {
        formData.append(fieldName, image);
      } else if (typeof image === "string" && image.startsWith("data:image/")) {
        // For base64 image, convert to Blob and append to formData
        const base64Data = image.split(",")[1];
        const byteString = atob(base64Data);
        const mimeType = image.match(/data:(.*?);base64,/)[1];
        const arrayBuffer = new Uint8Array(byteString.length);

        for (let i = 0; i < byteString.length; i++) {
          arrayBuffer[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([arrayBuffer], { type: mimeType });
        formData.append(fieldName, blob, `${fieldName}.jpg`);
      }
    }

    // Append images to formData
    appendImageToFormData(ironObject.image1, "image1");
    appendImageToFormData(ironObject.image2, "image2");
    appendImageToFormData(ironObject.image3, "image3");

    // Append preferredClub
    formData.append("preferredClub", ironObject.preferredClub);
    formData.append("project_id", projectid);

    formData.append("ironkey", ironObject.ironKey);
    if (key == "greeniron") {
      formData.append("saveIronStatus", true);
    }



    updatewhiteironimages(formData)
      .then((data) => {
        if (data?.code === 200) {
          if (data.data.status === false) {
            console.log("Status is false.");
          } else {
            console.log("Images updated successfully.", data.data.data.remotefittingdata);
            setRemotefittingdata(data.data.data.remotefittingdata);
            handleCloseModal();
          }
        } else {
          console.log(data.data?.message);
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      }).finally(() => {
        setIsLoading(false);
      });

  }

  useEffect(() => {
    console.log("remotefittingdata123", remoteData);
  }, [remoteData]);


  const savetoirontest = () => {
    setIsLoading(true);
    const data = {
      project_id: projectid
    }

    updateirontestdata(data).then((data) => {
      if (data?.code === 200) {
        // setRemotefittingdata(data.data);
        if (data.data.status === false) {
          console.log("status");
        } else {
          console.log(data.data);
          setRemotefittingdata(data?.data?.data?.remotefittingdata);
        }
      } else {
        console.log(data.data);
      }
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      setIsLoading(false);
    })
  }



  useEffect(() => {

    const squareDivs = document.querySelectorAll('.drop-box-xyz');

    squareDivs.forEach((squareDiv) => {
      // Get the width of each div
      const divWidth = squareDiv.offsetWidth;
      // setHeight(divWidth); // Assuming setHeight is a valid function in your context

      // Set the height to match the width (making it square)
      squareDiv.style.height = divWidth + 'px';
      console.log('Div width:', divWidth);
    });
    // window.addEventListener("resize", checkDevice);
    // return () => {
    //     window.removeEventListener("resize", checkDevice);
    // };
  }, [currentIron]);

  useEffect(() => {
  }, [currentIron]);

  useEffect(() => {
    if (!ironDataModal) {
      // When modal closes, restore scroll position
      window.requestAnimationFrame(() => {
        window.scrollTo(0, scrollPosition);
      });
    }
  }, [ironDataModal, scrollPosition]);

  useEffect(() => {
    if (ironDataModal) {
      // Store current scroll position
      // setScrollPosition(window.scrollY);
      document.querySelector('.remotefittingnewdesign').classList.add('modal-open');
    } else {
      // Cleanup when modal closes
      const cleanup = () => {
        document.querySelector('.remotefittingnewdesign')?.classList.remove('modal-open');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('width');
        document.body.style.removeProperty('height');
        document.body.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('--vh');

        // Restore scroll position
        window.scrollTo(0, scrollPosition);
      };

      cleanup();
    }

    return () => {
      // Cleanup on component unmount
      document.querySelector('.remotefittingnewdesign')?.classList.remove('modal-open');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('height');
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('--vh');
    };
  }, [ironDataModal]);


  useEffect(() => {
    console.log('scrollPosition-text', scrollPosition);
  }, [scrollPosition]);


  const [role_id, seRole_id] = useState(null);

  useEffect(() => {
    const getCurrentUserdata = getCurrentUser();
    // setUserdata(getCurrentUserdata.user);
    // setUser_id(getCurrentUserdata.user._id);


    if (getCurrentUserdata && getCurrentUserdata.user) {
      seRole_id(getCurrentUserdata.user.role_id);
    } else {
      console.error("Current user data is null or undefined");
    }

  }, []);



  const handleSelectionChange = (index, value, ironName, key) => {
    const newIronData = [...ironData];

    // Update the selected value
    newIronData[index].preferredClub = value;

    // Unlock the next dropdown if within range
    if (index + 1 < newIronData.length) {
      newIronData[index + 1].isOpen = true;
    }

    setIronData(newIronData);

    setIsLoading(true);
    const ironObject = ironData.find(color => color.ironClass === ironName);

    const formData = new FormData();

    formData.append("preferredClub", ironObject.preferredClub);
    formData.append("project_id", projectid);

    formData.append("ironkey", ironObject.ironKey);
    if (key == "greeniron") {
      formData.append("saveIronStatus", true);
    }



    updatepreferredclub(formData)
      .then((data) => {
        if (data?.code === 200) {
          if (data.data.status === false) {
            console.log("Status is false.");
          } else {
            setRemotefittingdata(data.data.data.remotefittingdata);
            // handleCloseModal();
          }
        } else {
          console.log(data.data?.message);
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      }).finally(() => {
        setIsLoading(false);
      });
  };


  console.log("ironDataironDataironDataironData", ironData);

  return (
    <>

      {
        isLoading == true ? (<><Loader2 /></>) : (<>

          <div
            className="row black_bg_box cf mx-3 mt-4 "
            style={{
              borderRadius: "40px",
              backgroundColor: "rgb(30, 32, 37)",
              pointerEvents: remoteData?.irondata?.status == true ? "none" : "auto",
            }}
          >
            <div className="club-fitting-card new-m">
              <div className="gab_title mb-0">
                <div className="collapsed d-flex align-items-center">
                  <div className="gab_icon m-0" style={{
                    backgroundColor: remoteData.irondata.status ? "#99ea24" : "",
                  }}>
                    <FaCheck />
                  </div>
                  <div className="gab_text ms-3"><h5 className='cf-title'>Iron Test</h5></div>
                </div>
              </div>
            </div>



            {ironData.map((color, index) => (
              <div key={index} className={`circle-color d-flex align-items-center justify-content-between mb-2 ${color.ironClass == "white" ? "" : ""}`
              }
              >
                <div
                  className={`gab_text ${color.name ? color.name.toLowerCase() : "default"}_box d-flex align-items-center`}
                >
                  <span className="color me-5"></span>
                  <p style={{ fontSize: "24px", fontWeight: "800" }}>
                    {color.ironLabel}
                  </p>
                </div>
                <select
                  className="form-select form-control dashboard-input-drop-3 select-custom-boxx w-25"
                  style={{
                    backgroundColor: color.preferredClub ? "rgb(153, 234, 36)" : "rgb(58, 66, 78)",
                    color: color.isOpen && color.preferredClub ? "#000000" : "#ffffff",
                    opacity: color.isOpen ? "1" : "0.6",
                    backgroundImage: `url("data:image/svg+xml;base64,${btoa(
                      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" stroke="${color.preferredClub ? "#000000" : "#ffffff"}" fill="none"         stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>`
                    )}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 5px center", // Moves the icon closer
                    backgroundSize: "22px", // Increased size of the icon
                  }}
                  disabled={!color.isOpen}
                  value={color.preferredClub}
                  onChange={(e) => handleSelectionChange(index, e.target.value, color.ironClass, color.ironKey)}
                >
                  <option value="" disabled >Preferred</option>
                  <option value="1" style={{ color: "#ffffff" }}>{color.ironLabel} 1</option>
                  <option value="2" style={{ color: "#ffffff" }}>{color.ironLabel} 2</option>
                  <option value="3" style={{ color: "#ffffff" }}>{color.ironLabel} 3</option>
                </select>


              </div>
            ))}

            <div className="save-attach d-flex align-items-center justify-content-between mt-3 mb-4 col-12">
              <button
                className="btn save-attach-btn col-12 py-4"
                
                disabled={
                  ((remoteData?.irondata?.whiteiron?.preferred_club != "" &&
                    remoteData?.irondata?.blackiron?.preferred_club != "" &&
                    remoteData?.irondata?.blueiron?.preferred_club != "" &&
                    remoteData?.irondata?.pinkiron?.preferred_club != "" &&
                    remoteData?.irondata?.purpleiron?.preferred_club != "" &&
                    remoteData?.irondata?.rediron?.preferred_club != "" &&
                    remoteData?.irondata?.orangeiron?.preferred_club != "" &&
                    remoteData?.irondata?.greeniron?.preferred_club != "") && remoteData?.irondata?.status == false) ? false : true
                }
                style={{ backgroundColor: "rgb(153, 234, 36)" }}
                onClick={() => savetoirontest()}
              >
                Save Iron Testing
              </button>
            </div>
          </div>

        </>)
      }
      <style>
        {`
    .dashboard-input-drop-3 {
    background-color: #41464F;
    border: 1px solid #41464F;
    border-radius: 12px;
    padding: 12px 12px;
    color: #ffffff ;
    font-size: 16px;
    font-weight: 600;
}



.black_bg_box .dashboard-input-drop-3 {
    font-size: 20px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    padding: 10px 20px;
    border-radius: 16px;
}


@media only screen and (min-width: 1920px) {
  .black_bg_box .dashboard-input-drop-3 {
      font-size: 22.5px;
      padding: 0 33px;
      height: 70px;
  }
}

@media only screen and (min-width: 1440px) and (max-width: 1600px) {
    .black_bg_box .dashboard-input-drop-3 {
      height: 65px;
      font-size: 19px;
  }
}
  @media only screen and (min-width: 1280px) and (max-width: 1439px){
    .black_bg_box .dashboard-input-drop-3 {
      height: 60px;
      font-size: 19px;
    }
  }
 @media only screen and (min-width: 992px) and (max-width: 1279px){
  .black_bg_box .dashboard-input-drop-3 {
    height: 55px;
    font-size: 19px;
    width: 155px !important;
    }
}
  @media only screen and (max-width: 675px){
    .black_bg_box .dashboard-input-drop-3 {
    font-size: 18px;
    width: 150px !important;
    }
  }
  `}
      </style>
    </>


  );
};

export default IronStudioData;
